<template>
  <div class="exam-option">
    <div class="avatar">
      <div
        class="brand_green_bg position-relative w-100 h-100"
        v-if="isSelected"
      >
        <div class="icon icon-accept brand_navy"></div>
      </div>

      <div class="avatar-text color_white_bg color_ash text-lowercase" v-else>
        {{ counter | getLetter }}
      </div>
    </div>

    <!-- VALUE  -->
    <div class="value color_grey_dark">
      <div class="text" v-html="option"></div>

      <!-- IMAGE OPTION  -->
      <!-- <div class="image-option">
        <img v-lazy="dynamicImg('sample-two.png')" alt="" />
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "ExamOption",

  props: {
    counter: Number,
    option: String,
    answer: String,
  },

  computed: {
    isSelected() {
      return this.convertValueToNum(this.answer) + 1 === this.counter
        ? true
        : false;
    },
  },

  filters: {
    getLetter(value) {
      if (value === 1) return "a";
      else if (value === 2) return "b";
      else if (value === 3) return "c";
      else if (value === 4) return "d";
      else return "e";
    },
  },

  watch: {
    option: {
      handler(value) {
        if (value.length) {
          this.formatOption();
        }
      },
      immediate: true,
    },
  },

  methods: {
    formatOption() {
      this.$nextTick(() => {
        document.querySelectorAll(".value").forEach((element) => {
          element.children.forEach((elm) => {
            // REMOVE BREAK TAGS
            elm.querySelectorAll("br").forEach((ele) => ele.remove());
            // REMOVE MARGINS
            elm.style.marginBottom = 0;
            elm.style.marginTop = "15px";
          });
        });

        let wirisExpression = document.createElement("script");
        wirisExpression.setAttribute(
          "src",
          "https://www.wiris.net/demo/plugins/app/WIRISplugins.js?viewer=image"
        );
        wirisExpression.setAttribute("async", true);
        wirisExpression.setAttribute("defer", true);
        document.head.appendChild(wirisExpression);
      });
    },

    convertValueToNum(value) {
      if (value.toLowerCase() === "a") return 0;
      else if (value.toLowerCase() === "b") return 1;
      else if (value.toLowerCase() === "c") return 2;
      else if (value.toLowerCase() === "d") return 3;
      else if (value.toLowerCase() === "e") return 4;
      else return 5;
    },
  },
};
</script>

<style lang="scss" scoped>
.exam-option {
  @include flex_row_start_nowrap;
  margin-bottom: 15px;
  width: 40%;

  .avatar {
    margin-right: 15px;
    font-size: 10.5px;

    .icon {
      @include transform_center;
      font-size: 18px;
    }
  }

  .value {
    font-size: 13px;
    line-height: 18px;

    img {
      min-height: 30px;
      height: auto;
      max-height: 60px;
      width: auto;
    }
  }
}
</style>
